import styled from "styled-components";

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media only screen and (min-width: 900px) {
    justify-content: normal;
    background-color: initial;
    padding: 0;
  }
`;

export const Container = styled.div`
  margin: 50px 0;
  background: #fff;
  padding: 32px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.08);
  width: 100%;

  @media only screen and (min-width: 900px) {
    max-width: 400px;
    margin: 50px auto;
    border-radius: 12px;
  }
`;

export const PageHeaderText = styled.h2`
  text-align: center;
  margin-bottom: 24px;
  font-weight: 600;
  font-size: 28px;
  color: #107400;
`;

export const BPLogo = styled.img`
  width: 272px;
  margin: 0 auto;
  margin-top: 4rem;
  z-index: 5;

  @media only screen and (min-width: 390px) {
    margin-top: 5.5rem;
  }

  @media only screen and (min-width: 480px) and (orientation: portrait) {
    margin-top: 2rem;
    margin-left: 2rem;
  }

  @media only screen and (min-width: 768px) {
    margin: 0 auto;
    margin-top: 40px;
  }
`;
